import { interval } from "./interval";

export const use1Second = interval(1e3);
